import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `availability` anchor component.
 * Keep in sync with AvailabilityProps in src/ui/uiConfig/anchorComponents/Availability/Availability.types.ts
 */
export const availabilityPropDocs: ComponentDocMap = {
  availabilityUnits: {
    description: 'Units rendered in the availability widget.',
    type: 'AvailabilityUnitWidget[]',
    example:
      '[{ unit_name: "boiler_a", unit_display_name: "Boiler A", kpi: { ui_config_id: 11 }, chart: { ui_config_id: 12 } }]',
  },
  'availabilityUnits[].unit_name': {
    description: 'Backend unit identifier.',
    type: 'string',
  },
  'availabilityUnits[].unit_display_name': {
    description: 'Display name shown in UI.',
    type: 'string',
  },
  'availabilityUnits[].kpi.ui_config_id': {
    description: 'UI config ID for the KPI card of this unit.',
    type: 'number',
  },
  'availabilityUnits[].chart.ui_config_id': {
    description: 'UI config ID for the chart card of this unit.',
    type: 'number',
  },
  systemId: {
    description: 'Current system ID (runtime injected).',
    type: 'number',
  },
}
